import { render, staticRenderFns } from "./DialogReadOnly.vue?vue&type=template&id=554f4d4e&scoped=true&"
import script from "./DialogReadOnly.vue?vue&type=script&lang=js&"
export * from "./DialogReadOnly.vue?vue&type=script&lang=js&"
import style0 from "./DialogReadOnly.vue?vue&type=style&index=0&id=554f4d4e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "554f4d4e",
  null
  
)

export default component.exports